module.exports = __webpack_public_path__ + "img/byhy@2x.76d409ec.png";